const LEGACY_STORAGE_KEYS: ReadonlyArray<readonly [string, string]> = [
  ["marco.manifest", "klint.manifest"],
  ["marco.localPacks", "klint.localPacks"],
  ["marco.chartServer", "klint.mapServer"],
  ["marco.view", "klint.view"],
  ["marco.hiddenMaps", "klint.hiddenMaps"],
];

/** Preserve maps and preferences created while Klint still used its working name. */
export function migrateLegacyStorage(): void {
  for (const [legacyKey, currentKey] of LEGACY_STORAGE_KEYS) {
    try {
      if (localStorage.getItem(currentKey) !== null) continue;
      const value = localStorage.getItem(legacyKey);
      if (value !== null) localStorage.setItem(currentKey, value);
    } catch {
      // Storage availability is checked by the normal startup path.
    }
  }
}
